import React from 'react';
import { Navigate } from 'react-router-dom';
import LocationPageTemplate from '../../components/SEO/LocationPageTemplate';
import { LocationPageSEO } from '../../components/SEO/LocationPageSEO';
import { CityData } from '../../data/locations';

interface LocationPageProps {
  city?: CityData;
  regionSlug?: string;
}

export default function LocationPage({ city, regionSlug }: LocationPageProps) {
  // Handle regional pages
  if (regionSlug && !city) {
    // For now, redirect to locations index
    // TODO: Implement regional templates
    return <Navigate to="/locations" replace />;
  }

  if (!city) {
    return <Navigate to="/locations" replace />;
  }

  return (
    <>
      <LocationPageSEO
        city={city.name}
        province={city.province}
        citySlug={city.name.toLowerCase().replace(/\s+/g, '-')}
        description={city.seoMetadata.description}
        keywords={city.seoMetadata.keywords}
      />
      <LocationPageTemplate city={city} />
    </>
  );
}